export default {
    name: 'ShareButtonTwitter',
    props: [
        'url',
        'text',
        'bodyText',
    ],
    computed: {
        twitterShareUrl: function () {
            return 'https://twitter.com/share?url=' + encodeURIComponent(this.url) + '&text=' + encodeURIComponent(this.text);
        }
    }
}

